import { useContext } from "react";
import ChatbotContext, { ChatbotContextValue } from "./ChatbotContext";

/**
 * Hook to consume ChatbotContext
 * @throws Error if used outside ChatbotProvider
 */
export const useChatbotContext = (): ChatbotContextValue => {
  const context = useContext(ChatbotContext);

  if (!context) {
    throw new Error("useChatbotContext must be used within ChatbotProvider");
  }

  return context;
};

export default useChatbotContext;
